import IconElement from './IconElement';
import IconElementPresets from './IconElementPresets';
import IconElementMetaData from './IconElementMetaData';
import IconElementProps from './IconElementProps';
import * as methods from './IconElementMethods';
import { DATA_PANELS } from 'crazyEditor/core/constants/panelConstants';

export default {
  metaData: IconElementMetaData,
  elementClass: IconElement,
  elementProps: IconElementProps,
  presets: IconElementPresets,
  panel: DATA_PANELS.ICON,
  methods
};
